

























import { computed, defineComponent, toRefs } from '@nuxtjs/composition-api'
import { useId } from '~/compositions/id'

export default defineComponent({
  model: {
    prop: 'checked',
    event: 'input'
  },
  props: {
    value: {
      type: [String, Number],
      required: false,
      default: null
    },
    checked: {
      type: [String, Number],
      required: false,
      default: null
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    id: {
      type: String,
      default: null
    },
    large: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: null
    }
  },
  setup(props, { emit }) {
    const { id, checked, large, disabled } = toRefs(props)

    const { createRandomId } = useId()
    const internalId = id.value ?? createRandomId()

    const internalValue = computed({
      get() {
        return checked.value
      },
      set(value) {
        emit('input', value)
        emit('change', value)
      }
    })

    const radioClasses = computed(() => [
      ...(large.value
        ? ['tw-h-6', 'tw-w-6']
        : ['tw-h-5', 'tw-w-5', 'lg:tw-h-4', 'lg:tw-w-4']),
      ...(disabled.value
        ? [
            'tw-cursor-not-allowed',
            'checked:tw-opacity-50',
            'tw-border-grey-300'
          ]
        : [
            'tw-cursor-pointer',
            'focus:tw-ring-primary',
            'tw-border-grey-400',
            'group-hover:tw-border-primary'
          ])
    ])

    const wrapperClasses = computed(() => [
      ...(large.value ? ['!tw-mt-1', '!tw-mb-1'] : [])
    ])

    const labelClasses = computed(() => [
      ...(disabled.value
        ? ['tw-text-grey-500', 'tw-cursor-not-allowed']
        : ['group-hover:tw-text-primary', 'tw-cursor-pointer']),
      ...(large.value ? ['tw-text-lg'] : ['tw-text-base'])
    ])

    return {
      internalId,
      internalValue,
      radioClasses,
      wrapperClasses,
      labelClasses
    }
  }
})
